export const EMBED_PATH_PREFIX = "/embed/";

export function isEmbedDocument(pathname: string): boolean {
  return pathname.startsWith(EMBED_PATH_PREFIX);
}
